"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
/**
 * Set the find favorites text
 * @param text The search text to set
 */
exports.default = satcheljs_1.mutatorAction('setFindText', function setFindText(text) {
    store_1.default.findText = text;
});
//# sourceMappingURL=setFindText.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-find-favorites-store/lib/actions/setFindText.js
// module id = 6282
// module chunks = 68